export interface MembershipPresaleInfo {
    MembershipTypeID:                          string;
    MembershipName:                            string;
    PresaleDate:                               Date;
    IsActiveMembershipPresale:                 boolean;
    IsInMembershipCardPreSaleAndHaveValidCard: boolean;
    ModelID:                                   string;
    IsReadonly:                                boolean;
    ParentModelID:                             string;
    ParentPropertyName:                        string;
    ListName:                                  string;
    IsNewModel:                                boolean;
    SelfCheckForModification:                  boolean;
}